module.exports = __webpack_public_path__ + "static/media/stephanieFish.a46ab877.jpg";